import { render } from "./product-details-component.vue?vue&type=template&id=2a31aabc"
import script from "./product-details-component.vue?vue&type=script&lang=js"
export * from "./product-details-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__